import { useDispatch } from 'react-redux';
import React, { useEffect, useCallback } from 'react';
import { prop, pick, path } from 'ramda';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'js/hooks/navigate';
import { getCleanPath } from 'js/utils/url.util';
import { Redirect } from 'js/components/common/Redirect';
import { useLoginPopup } from 'js/components/popups/LoginPopup';
import { useAppSelector, useUserSelector } from 'js/store/hooks';

import * as actions from './store/actions';

export const BonusMultiviewBonusDetailsPopupLauncher = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const showLoginPopup = useLoginPopup();
    const { seoFriendlyBonusName } = useParams();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const { rootPage, bonusesConfiguration = [] } = useAppSelector(pick(['rootPage', 'bonusesConfiguration']));
    const bonus = bonusesConfiguration.find(item => item.seoFriendlyBonusName === seoFriendlyBonusName.toLowerCase());
    const bonusPage = getCleanPath(useAppSelector(path(['bonusManagementPreferences', 'bonusDeepLinkingUrl'])) || 'promotions');

    const navigateToBonusPage = useCallback(() => {
        navigate(`${bonusPage}/${seoFriendlyBonusName}`);
    }, [navigate, bonusPage, seoFriendlyBonusName]);

    useEffect(() => {
        if (!bonus) {
            return;
        }

        const isShowForLoggedIn = bonus.showFor === 'LOGGED_IN';
        const isShowForBoth = bonus.showFor === 'BOTH';

        if (!isShowForBoth && isLoggedIn !== isShowForLoggedIn) {
            navigate(rootPage);

            if (!isLoggedIn) {
                showLoginPopup({ onLogin: navigateToBonusPage });
            }

            return;
        }

        dispatch(actions.showBonusDetailsPopupAction(bonus));
    }, [bonus, isLoggedIn, dispatch, showLoginPopup, navigateToBonusPage, navigate, rootPage]);

    if (!bonus) {
        return <Redirect to={rootPage} />;
    }

    return null;
};
